import constants from "../constants";
import Store from "../store/Store";

const axios = require('axios');

class Api {
    static async IndexedDb() {
        return await new Promise(async function (resolve) {
            var request = await indexedDB.open(constants.IDB_NAME, constants.IDB_VERSION);
            var db;
            request.onsuccess = async function (event) {
                db = event.target.result;
                return resolve(db);
            };
            request.onupgradeneeded = async function (event) {
                db = event.target.result;

                if (!db.objectStoreNames.contains("taskLastSync")) {
                    db.createObjectStore("taskLastSync", { keyPath: "id" });
                }
                if (!db.objectStoreNames.contains("tables")) {
                    db.createObjectStore("tables", { keyPath: "table_id" });
                }
                if (!db.objectStoreNames.contains("parcels")) {
                    db.createObjectStore("parcels", { keyPath: "id" });
                }
                if (!db.objectStoreNames.contains("groupedParcels")) {
                    db.createObjectStore("groupedParcels", { keyPath: "id" });
                }
                if (!db.objectStoreNames.contains("harvestYears")) {
                    db.createObjectStore("harvestYears", { keyPath: "id" });
                }
                if (!db.objectStoreNames.contains("groupedYears")) {
                    db.createObjectStore("groupedYears"); 
                }
                if (!db.objectStoreNames.contains("user")) {
                    db.createObjectStore("user", { autoIncrement: true });
                }
                if (!db.objectStoreNames.contains("actualHarvestYear")) {
                    db.createObjectStore("actualHarvestYear", { keyPath: "id" });
                }
                if (!db.objectStoreNames.contains("tasks")) {
                    db.createObjectStore("tasks", { keyPath: "guid" });
                }
                if (!db.objectStoreNames.contains("tableLastSync")) {
                    db.createObjectStore("tableLastSync", { autoIncrement: true });
                }
                if (!db.objectStoreNames.contains("farms")) {
                    db.createObjectStore("farms", { keyPath: "id" });
                }
                if (!db.objectStoreNames.contains("operations")) {
                    db.createObjectStore("operations", { keyPath: "id" });
                }

                event.target.transaction.oncomplete = function () {
                    resolve(db);
                };
            };
        });
    }

    static async getFromIDB(store) {
        return await Api.IndexedDb().then((db) => {
            return new Promise(async function (resolve) {
                var transaction = db.transaction([store]);
                var objectStore = transaction.objectStore(store);
                var request = objectStore.getAll();
                request.onsuccess = function (event) {
                    return resolve(event.target.result);
                };
            });
        })
    }

    static async sendOfflineData() {
        let tasks = await Api.getFromIDB('tasks');
        for (let i = 0; i < tasks.length; i++) {
            let task = tasks[i];
            if (task.dirty) {
                let param = {
                    id: task.guid,
                    task: task
                };
                await Api.updateTask(param);
            }
        }
    }

    static async getHarvestYear() {
        const { user } = Store.getState();
        const url = constants.API_URL + 'common/preselect';
        const data = {
            user_id: user.id,
            token: user.token
        };
    
        try {
            const response = await axios.post(url, JSON.stringify(data), constants.POST_HEADER);
            const result = response.data;
            
            const db = await Api.IndexedDb();
    
            if (result.success) {
                // 1. harvestYears mentése IDB-be
                const harvestYearsStore = db.transaction("harvestYears", "readwrite").objectStore("harvestYears");
                harvestYearsStore.clear();
                result.harvest_years.forEach(item => {
                    harvestYearsStore.add(item);
                });
                Store.dispatch({ type: 'harvestYears', value: result.harvest_years });

                // 1/b csoportosított évek tárolása
                // console.log("Létezik-e groupedYears store?", db.objectStoreNames.contains("groupedYears"));

                let groupedYears = result.groupedYears;
                try {
                    let groupedYearsStore = db.transaction("groupedYears", "readwrite").objectStore("groupedYears");
                    groupedYearsStore.clear();
                    groupedYearsStore.put(groupedYears, "data");
                    // console.log("groupedYears sikeresen mentve");
                } catch (err) {
                    console.error("groupedYears mentési hiba:", err);
                }
                Store.dispatch({ type: 'groupedYears', value: groupedYears });
              

                // 2. actualHarvestYear kezelése
                const existing = await Api.getAllFromStore(db, "actualHarvestYear");
    
                if (existing && existing.length > 0) {
                    Store.dispatch({ type: 'actualHarvestYear', value: existing[0].value });
                } else {
                    await Api.addToStore(db, "actualHarvestYear", {
                        id: result.actual,
                        value: result.actual
                    });
                    Store.dispatch({ type: 'actualHarvestYear', value: result.actual });
                }
    
            } else {
                await Api.restoreHarvestYearFromIDB();
            }
    
            return true;
    
        } catch (e) {
            await Api.restoreHarvestYearFromIDB();
            return false;
        }
    }

    static async getTables() {
        const {user, actualHarvestYear} = Store.getState();
        const url = constants.API_URL + 'table/index';
        //let last_sync = localStorage.getItem('tableLastSync')
        const data = {
            user_id: user.id,
            token: user.token,
            harvest_year_id: actualHarvestYear,
            //last_sync:last_sync
        };
        return await axios.post(url, JSON.stringify(data), constants.POST_HEADER)
            .then(async (response) => {
                let result = response.data;
                if (result.success) {
                    Api.IndexedDb().then((db) => {
                        let tablesStore = db.transaction("tables", "readwrite").objectStore("tables");
                        tablesStore.clear();
                        result.tables.forEach((item) => {
                            tablesStore.add(item);
                        });
                    });

                    Store.dispatch({type: 'tables', value: result.tables});
                } else {
                    let tables = await Api.getFromIDB('tables')
                    Store.dispatch({type: 'tables', value: tables});
                }
                return true;
            }).catch(async (e) => {
                let tables = await Api.getFromIDB('tables')
                Store.dispatch({type: 'tables', value: tables});
                return false;
            });
    }

    static async getParcels() {
        const { user, actualHarvestYear, tables } = Store.getState();
        const table_ids = tables.map(table => table.table_id); // collect table ids
    
        if (table_ids.length === 0) {
            return;
        }
    
        const url = constants.API_URL + 'table/get-parcels';
        const data = {
            user_id: user.id,
            token: user.token,
            harvest_year_id: actualHarvestYear,
            table_ids: table_ids
        };
    
        return await axios.post(url, JSON.stringify(data), constants.POST_HEADER)
            .then(async (response) => {
                let result = response.data;

                if (result.success) {
                    // object to array
                    let parcelsArray = Array.isArray(result.parcels) ? result.parcels : Object.values(result.parcels);
                
                    Api.IndexedDb().then((db) => {
                        let parcelsStore = db.transaction("parcels", "readwrite").objectStore("parcels");
                        parcelsStore.clear();
                
                        let groupedByTableId = {};
                
                        parcelsArray.forEach((item) => {
                            if (!groupedByTableId[item.table_id]) {
                                groupedByTableId[item.table_id] = [];
                            }
                            // Hozzáadjuk az id-t és a parcel_name-t
                            groupedByTableId[item.table_id].push({
                                parcel_id: item.id,
                                parcel_name: item.parcel_name
                            });
                        
                            parcelsStore.add(item);
                        })
                
                        Store.dispatch({ type: 'parcels', value: parcelsArray });
                        Store.dispatch({ type: 'groupedParcels', value: groupedByTableId });
                    });
                } else {
                    let parcels = await Api.getFromIDB('parcels')
                    Store.dispatch({type: 'parcels', value: parcels});
                }
                return true;
            }).catch(async (e) => {
                let parcels = await Api.getFromIDB('parcels')
                Store.dispatch({type: 'parcels', value: parcels});
                return false;
            });
    }
    

    static async getTasks() {
        const {user, actualHarvestYear} = Store.getState();
        const url = constants.API_URL + 'task/all-task';
        const data = {
            user_id: user.id,
            token: user.token,
            harvest_year_id: actualHarvestYear,
        };
        return await axios.post(url, JSON.stringify(data), constants.POST_HEADER)
            .then(async (response) => {
                let result = response.data;
                if (result.success) {
                    Api.IndexedDb().then((db) => {
                        let tasksStore = db.transaction("tasks", "readwrite").objectStore("tasks");
                        tasksStore.clear();
                        result.tasks.forEach((item) => {
                            item.dirty = 0;
                            tasksStore.add(item);
                        });
                    });
                    localStorage.setItem('taskLastSync', Math.round(+new Date() / 1000) + (60 * 60));
                    Store.dispatch({type: 'tasks', value: result.tasks});
                } else {
                    let tasks = await Api.getFromIDB('tasks')
                    Store.dispatch({type: 'tasks', value: tasks});
                }
                return true;
            }).catch(async (e) => {
                let tasks = await Api.getFromIDB('tasks')
                Store.dispatch({type: 'tasks', value: tasks});
                return false;
            });
    }

    static async setSubscribeToken() {
        const {user, firebase_subscribe_token} = Store.getState();
        let data = {
            user_id: user.id,
            token: user.token,
            firebase_token: firebase_subscribe_token
        };
        await axios.post(constants.API_URL + 'user/set-firebase-token', JSON.stringify(data), constants.POST_HEADER)
            .catch(async (e) => {
                return false;
            });
    }

    static async updateTask(param) {
        const {user} = Store.getState();
        const url = constants.API_URL + 'task/update';

        const data = {
            user_id: user.id,
            token: user.token,
            ...param
        };


        const formData = new FormData();
        for (const key in data) {
            if (typeof data[key] === 'object' && data[key] !== null) {
                formData.append(key, JSON.stringify(data[key]));
            } else {
                formData.append(key, data[key]);
            }
        }
        
        if (data.task && data.task.image instanceof File) {
            formData.append('image', data.task.image);
        }
        
        return await axios.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then((response) => {
                let result = response.data;
                if (!result.success) {
                    console.log(result)
                    alert(result.error);
                    return false;
                } else {
                    Api.getTasks();
                    alert('Sikeres mentés');
                }
                return true;
            }).catch(async (e) => {
                alert('Sajnos nem tudtuk elmenteni a változásokat mert nincs internetkapcsolat! Amint lesz internet kapcsolata, az adatokat automatikusan feldolgozzuk.');
                await Api.IndexedDb().then((db) => {
                    return new Promise(async function (resolve) {
                        var transaction = db.transaction(['tasks'], 'readwrite');
                        var objectStore = transaction.objectStore('tasks');
                        var request = objectStore.put(param.task);
                        request.onsuccess = function (event) {
                            // let data = event.target.result;
                            // console.log(data);
                            // console.log(param.task);
                            return resolve(true);
                        };
                    });
                });
                return true;

            });
    }


    static async insertTaskNote(formData) {
        const { user } = Store.getState();

        const data = new FormData();
        data.append('user_id', user.id);
        data.append('token', user.token);
        data.append('model_id', formData.note.model_id);
        data.append('text', formData.note.text);

        let note_type = formData.note.note_type ?? 'task'; // task v table (a típus meghatározza a végpontot!)
        const url = constants.API_URL + note_type+'/insert-note';
    
        if (formData.note.image) {
            data.append('image', formData.note.image);
        }
    
        console.log("Küldött FormData:");
        for (let [key, value] of data.entries()) {
            console.log(key, value);
        }
    
        return await axios.post(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((response) => {
            let result = response.data;
            if (!result.success) {
                console.log(result);
                alert(result.error);
                return false;
            } else {
                Api.getTasks();
                Api.getTables();
                //alert('Sikeres mentés');
            }
            return true;
        }).catch(async (e) => {
            alert('Sajnos nem tudtuk elmenteni a változásokat mert nincs internetkapcsolat!');
            // offline mentés IndexedDB-be
            await Api.IndexedDb().then((db) => {
                return new Promise(async function (resolve) {
                    var transaction = db.transaction(['tasks'], 'readwrite');
                    var objectStore = transaction.objectStore('tasks');
                    var request = objectStore.put(formData.note); // csak offline mentésre
                    request.onsuccess = function (event) {
                        return resolve(true);
                    };
                });
            });
            return true;
        });
    }

    static async updateNote(formData) {
        const { user } = Store.getState();
    
        const data = new FormData();
        data.append('user_id', user.id);
        data.append('token', user.token);
        data.append('note_id', formData.note_id);
        data.append('text', formData.note.text);

        let note_type = formData.note_type ?? 'table'; // task v table (a típus meghatározza a végpontot!)
        const url = constants.API_URL + note_type +'/update-note';

        if (formData.note.image === null) {
            data.append('image', 'null');
        } else {
            data.append('image', formData.note.image);
        }
    
        console.log("Küldött FormData:");
        for (let [key, value] of data.entries()) {
            console.log(key, value);
        }
    
        return await axios.post(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((response) => {
            let result = response.data;
            if (!result.success) {
                console.log(result);
                alert(result.error);
                return { success: false, error: result.error };
            } else {
                Api.getTasks();
                Api.getTables();
                return { success: true };
            }
        }).catch(async (e) => {
            await Api.IndexedDb().then((db) => {
                return new Promise(async function (resolve) {
                    var transaction = db.transaction(['tasks'], 'readwrite');
                    var objectStore = transaction.objectStore('tasks');
                    var request = objectStore.put(formData.note);
                    request.onsuccess = function (event) {
                        return resolve(true);
                    };
                });
            });
            return { success: true, offline: true };
        });
    }
    
    
    static async sendTaskToNebih(param) {
        const {user} = Store.getState();
        const url = constants.API_URL + 'nebih/send-task';

        const data = {
            user_id: user.id,
            token: user.token,
            ...param
        };


        return await axios.post(url, JSON.stringify(data), constants.POST_HEADER)
            .then((response) => {
                let result = response.data;
                if (!result.success) {
                    console.log(result)
                    alert(result.error);
                    return false;
                } else {
                    Api.getTasks();
                    alert('Sikeres beküldés');
                }
                return true;
            }).catch(async (e) => { // TODO ellenőrizni ez jó e ha OFFLINE vagyunk
                alert('Sajnos nem tudtuk elmenteni a változásokat mert nincs internetkapcsolat! Amint lesz internet kapcsolata, az adatokat automatikusan feldolgozzuk.');
                await Api.IndexedDb().then((db) => {
                    return new Promise(async function (resolve) {
                        var transaction = db.transaction(['tasks'], 'readwrite');
                        var objectStore = transaction.objectStore('tasks');
                        var request = objectStore.put(param.task);
                        request.onsuccess = function (event) {
                            // let data = event.target.result;
                            // console.log(data);
                            // console.log(param.task);
                            return resolve(true);
                        };
                    });
                });
                return true;

            });
    }

    static forgotPassword(email) {
        let url = constants.API_URL + "user/forgot-password"
        let data = {
            username: email
        }
        axios.post(url, JSON.stringify(data), constants.POST_HEADER)
            .then((response) => {
                let result = response.data;
                if (result.success) {
                    alert('Az új jelszó beállításához szükséges email-t elküldtük!');
                } else {
                    alert(result.error);

                }
                return true;
            }).catch((e) => {
            alert('Sajnos hiba történt, kérjük próbálja meg később!');
            return false;
        });
    }

    static async login(username, password) {
        let url = constants.API_URL + 'user/login';
        let data = {
            username: username,
            password: password
        };

        return await axios.post(url, JSON.stringify(data), constants.POST_HEADER)
            .then(async (response) => {
                let result = response.data;
                if (result.success) {
                    let user = result.user;
                    user.token = result.token;
                    user.permissions = result.permissions; // jogosultságok eltárolása

                    Api.IndexedDb().then((db) => {
                        let userStore = db.transaction("user", "readwrite").objectStore("user");
                        userStore.clear();
                        userStore.add(user);
                    });
                    Store.dispatch({type: 'user', value: result.user});
                    Store.dispatch({type: 'loading', value: true});
                    Store.dispatch({type: 'isLoggedIn', value: true});
                    if (user && user.username) {
                        await Api.sendOfflineData()
                        await Api.getHarvestYear();
                        await Api.getTables();
                        await Api.getParcels();
                        await Api.setSubscribeToken()
                        await Api.getTasks();
                        await Api.getFarms();
                        await Api.getOperations();
                        Store.dispatch({type: 'loading', value: false});
                    }
                } else {
                    alert(result.error);
                }
                return true;
            }).catch(async (e) => {
                return false;
            });
    }

    static async logout() {
        await Api.sendOfflineData();
        //megnézzük hogy van-e offline létrehozott/módosított adat

        let hasOfflineData = false;
        let tasks = await Api.getFromIDB('tasks');
        for (let i = 0; i < tasks.length; i++) {
            let task = tasks[i];
            if (task.dirty) {
                hasOfflineData = true;
            }
        }
        if(!hasOfflineData || (hasOfflineData && window.confirm('Kilépéskor az offline tárolt adatokat töröljük. Biztosan ki szeretne lépni? During logoff, data stored offline will be deleted. Do you want to continue?'))){
            const {user} = Store.getState();
            const url = constants.API_URL + 'user/logout';
            const data = {
                user_id: user.id,
                token: user.token,
            };
            indexedDB.deleteDatabase(constants.IDB_NAME);

            Store.dispatch({type: 'loading', value: false});
            Store.dispatch({type: 'isLoggedIn', value: false});
            Store.dispatch({type: 'user', value: {}});
            return await axios.post(url, JSON.stringify(data), constants.POST_HEADER)
                .then(async (response) => {
                    let result = response.data;
                    if (!result.success) {
                        alert(result.error);
                    }
                    return true;
                }).catch(async (e) => {
                    return false;
                });

        }

    }

    static async initUser() {
        let user = await Api.getFromIDB('user');

        if (user.length === 0) {
            Store.dispatch({type: 'user', value: {}});
            Store.dispatch({type: 'isLoggedIn', value: false});
            Store.dispatch({type: 'loading', value: false});
            return false;
        }
        if (user && user[0]) {
            user = user[0];
        }
        const url = constants.API_URL + 'user/validate-user';
        const data = {
            user_id: user.id,
            token: user.token,
        };
        axios.post(url, data, constants.POST_HEADER).then(async (response) => {
            if (response.data.success) {
                if (user && user.username) {
                    // jogosultságok
                    user.permissions = response.data.permissions; // jogosultságok frissítése

                    Store.dispatch({type: 'user', value: user});
                    Store.dispatch({type: 'isLoggedIn', value: true});
                } else {
                    indexedDB.deleteDatabase(constants.IDB_NAME);
                    Store.dispatch({type: 'user', value: {}});
                    Store.dispatch({type: 'isLoggedIn', value: false});
                    Store.dispatch({type: 'loading', value: false});
                }
                //Aratási évek betöltése
                if (user && user.username) {
                    await Api.sendOfflineData()
                    await Api.getHarvestYear();
                    await Api.getTables();
                    await Api.getParcels();
                    await Api.setSubscribeToken()
                    await Api.getTasks();
                    await Api.getFarms();
                    await Api.getOperations();
                    Store.dispatch({type: 'loading', value: false});
                }
            } else {
                indexedDB.deleteDatabase(constants.IDB_NAME);
                Store.dispatch({type: 'loading', value: false});
                Store.dispatch({type: 'isLoggedIn', value: false});
                Store.dispatch({type: 'user', value: {}});
                alert(response.data.error);
            }
        }).catch(async (e) => {
            if (user && user.username) {
                Store.dispatch({type: 'user', value: user});
                Store.dispatch({type: 'isLoggedIn', value: true});
            } else {
                Store.dispatch({type: 'user', value: {}});
                Store.dispatch({type: 'isLoggedIn', value: false});
                Store.dispatch({type: 'loading', value: false});
            }
            //Aratási évek betöltése
            if (user && user.username) {
                await Api.sendOfflineData()
                await Api.getHarvestYear();
                await Api.getTables();
                await Api.getParcels();
                await Api.setSubscribeToken()
                await Api.getTasks();
                await Api.getFarms();
                await Api.getOperations();
                Store.dispatch({type: 'loading', value: false});
            }
        });

    }

    static async getFarms() {
        const {user, actualHarvestYear} = Store.getState();
        const url = constants.API_URL + 'common/get-farms';
        const data = {
            user_id: user.id,
            token: user.token,
            harvest_year_id: actualHarvestYear,
        };
        return await axios.post(url, JSON.stringify(data), constants.POST_HEADER)
            .then(async (response) => {
                let result = response.data;
                if (result.success) {
                    Api.IndexedDb().then((db) => {
                        let farmsStore = db.transaction("farms", "readwrite").objectStore("farms");
                        farmsStore.clear();
                        result.farms.forEach((item) => {
                            farmsStore.add(item);
                        });
                    });
                    Store.dispatch({type: 'farms', value: result.farms});
                } else {
                    let farms = await Api.getFromIDB('farms');
                    Store.dispatch({type: 'farms', value: farms});
                }
            }).catch(async (e) => {
                let farms = await Api.getFromIDB('farms')
                Store.dispatch({type: 'farms', value: farms});
                return false;
            });

    }

    static async getOperations() {
        const {user, actualHarvestYear} = Store.getState();
        const url = constants.API_URL + 'task/get-operations';
        const data = {
            user_id: user.id,
            token: user.token,
            harvest_year_id: actualHarvestYear,
        };
        return await axios.post(url, JSON.stringify(data), constants.POST_HEADER)
            .then(async (response) => {
                let result = response.data;
                if (result.success) {
                    Api.IndexedDb().then((db) => {
                        let operationStore = db.transaction("operations", "readwrite").objectStore("operations");
                        operationStore.clear();
                        result.operations.forEach((item) => {
                            operationStore.add(item);
                        });
                    });
                    Store.dispatch({type: 'operations', value: result.operations});
                } else {
                    let operations = await Api.getFromIDB('operations');
                    Store.dispatch({type: 'operations', value: operations});
                }
            }).catch(async (e) => {
                let operations = await Api.getFromIDB('operations')
                Store.dispatch({type: 'operations', value: operations});
                return false;
            });

    }

    static getAllFromStore(db, storeName) {
        return new Promise((resolve, reject) => {
            const tx = db.transaction(storeName, "readonly");
            const store = tx.objectStore(storeName);
            const request = store.getAll();
    
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });
    }
    
    static addToStore(db, storeName, value) {
        return new Promise((resolve, reject) => {
            const tx = db.transaction(storeName, "readwrite");
            const store = tx.objectStore(storeName);
            const request = store.add(value);
    
            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
        });
    }

    static async restoreHarvestYearFromIDB() {
        const actualHarvestYear = await Api.getFromIDB('actualHarvestYear');
        const harvestYears = await Api.getFromIDB('harvestYears');
        const groupedYears = await Api.getFromIDB('groupedYears');
    
        Store.dispatch({
            type: 'actualHarvestYear',
            value: actualHarvestYear?.[0]?.value || actualHarvestYear?.value || null
        });
        Store.dispatch({ type: 'harvestYears', value: harvestYears || [] });
        Store.dispatch({ type: 'groupedYears', value: groupedYears || [] });
    }
    
}

export default Api